// Check if browser supports smooth scroll behavior
if ('scrollBehavior' in document.documentElement.style) {
    // Get all buttons
    let buttons = document.querySelectorAll(".scrollToTopBtn");

    // Add click event to each button
    buttons.forEach(button => {
        button.onclick = function() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
    });
} else {
    // Polyfill for smooth scroll behavior
    let buttons = document.querySelectorAll(".scrollToTopBtn");

    // Add click event to each button
    buttons.forEach(button => {
        button.onclick = function() {
            smoothScrollToTop();
        };
    });

    function smoothScrollToTop() {
        const startPosition = window.pageYOffset;
        const duration = 10000; // Duration of the animation in milliseconds
        const startTime = performance.now();

        function scrollStep(timestamp) {
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easing = easeInOutCubic(progress);
            window.scrollTo(0, startPosition * (1 - easing));

            if (elapsed < duration) {
                requestAnimationFrame(scrollStep);
            }
        }

        requestAnimationFrame(scrollStep);
    }

    // Easing function for smooth scrolling
    function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
}

  